import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { IAuthUserCompanyOutlet } from "../../contexts/AuthProvider/AuthProvider";

export const OtherUserLogin: React.FC = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const { otherUserLogin } = useAuth();

  // Parse the URL parameters
  const searchParams = new URLSearchParams(location.search);
  const token = JSON.parse(
    decodeURIComponent(searchParams.get("token") || "{}")
  );
  const userId = searchParams.get("user_fact_id");
  const affilated_company_outlet_uuids = JSON.parse(
    decodeURIComponent(
      searchParams.get("affilated_company_outlet_uuids") || "[]"
    )
  );

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchDetails = async () => {
      if (!token || !userId) {
        setError("Missing required parameters");
        setLoading(false);
        return;
      }

      setLoading(true);
      otherUserLogin(
        token,
        userId,
        affilated_company_outlet_uuids,
        (isSuccess, error) => {
          setLoading(false);
          if (!isSuccess && error) {
            setError(error);
          } else {
            navigate("/dashboard");
          }
        }
      );
    };

    fetchDetails();
  }, [token, userId, affilated_company_outlet_uuids, otherUserLogin, navigate]);

  if (loading) {
    return <div>Loading....</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ padding: "20px", border: "1px solid red" }}>
      <h1>Other User Login Component</h1>
      <p>Current URL: {window.location.href}</p>
      <p>Search params: {window.location.search}</p>
    </div>
  );
};
